<template>
  <div class="px-4 px-lg-12 py-12 d-flex flex-column align-center justify-center" style="height: 100vh">
    <template>
      <animated-check-icon />
      <div :key="percentage" class="text-h6 mt-10 mb-6 text-center">Congratulations! Your website is ready.</div>
      <v-btn :href="newRegistration.url" color="primary">
        <v-icon left>mdi-web</v-icon>Go To Website
      </v-btn>
    </template>
  </div>
</template>

<script>
import AnimatedCheckIcon from "@/components/AnimatedCheckIcon.vue";

export default {
  name: "Success",

  components: { AnimatedCheckIcon },

  computed: {
    newRegistration() {
      return JSON.parse(sessionStorage.getItem("newRegistration") || "{}");
    },
  },
};
</script>